import request from '@/utils/request'

const base = direction => `/erp/stock/other-${direction}`

export const listOtherStockDocuments = (direction, params) => request({
  url: base(direction) + '/list', method: 'get', params
})

export const getOtherStockDocument = (direction, id) => request({
  url: base(direction) + '/detail', method: 'get', params: { id }
})

export const saveOtherStockDocument = (direction, data) => request({
  url: base(direction) + '/save', method: 'post', data
})

export const auditOtherStockDocument = (direction, id) => request({
  url: base(direction) + '/audit', method: 'post', data: { id }
})

export const reverseOtherStockDocument = (direction, id) => request({
  url: base(direction) + '/reverse-audit', method: 'post', data: { id }
})

export const deleteOtherStockDocument = (direction, id) => request({
  url: base(direction) + '/delete', method: 'post', data: { id }
})

export const otherStockSkuOptions = (direction, warehouseId, keyword) => request({
  url: base(direction) + '/sku-options', method: 'get', params: { warehouseId, keyword }
})
